// Wheel of Life Categories and Questions
export const wheelCategories = [
  {
    id: 'salud',
    name: 'Salud',
    color: '#f48fb1',
    questions: [
      'Me ocupo de mi estado físico (ejercicio, alimentación, etc.).',
      'Mantengo un buen equilibrio mental y emocional.',
      'Duermo lo suficiente y descanso adecuadamente.',
      'Consulto profesionales de la salud cuando es necesario.',
      'Realizo chequeos médicos o exámenes preventivos regularmente.',
      'Me hidrato bien durante el día.',
      'Cuento con hábitos saludables (buenas posturas, pausas activas, etc.).',
      'Escucho las señales de mi cuerpo y atiendo mis necesidades.'
    ]
  },
  {
    id: 'finanzas',
    name: 'Finanzas',
    color: '#81c784',
    questions: [
      'Tengo un control regular de mis ingresos y gastos.',
      'Mantengo ahorros o fondos de emergencia.',
      'Mis deudas o compromisos financieros están bajo control.',
      'Me siento seguro/a con mi situación económica.',
      'Tengo metas financieras claras (ahorro, inversión, etc.).',
      'Tengo un presupuesto o plan de gastos mensuales.',
      'Busco educarme financieramente (lecturas, cursos, etc.).',
      'Siento que mi relación con el dinero es positiva.'
    ]
  },
  {
    id: 'familiar',
    name: 'Familiar',
    color: '#64b5f6',
    questions: [
      'Me siento cercano/a y apoyado/a por mi familia.',
      'Comparto momentos de calidad con mis seres queridos.',
      'Practico la comunicación abierta y honesta en mi familia.',
      'Siento un ambiente armónico en mi hogar.',
      'Participamos en actividades familiares que fortalecen la unión.',
      'Expreso afecto y gratitud a mi familia con regularidad.',
      'Manejo de manera adecuada los conflictos familiares.',
      'Me siento responsable y cumplo mi rol dentro de la familia.'
    ]
  },
  {
    id: 'profesional',
    name: 'Profesional',
    color: '#ffb74d',
    questions: [
      'Me siento realizado/a con mi trabajo o carrera.',
      'Tengo metas claras de crecimiento profesional.',
      'Siento que mi trabajo me permite usar mis habilidades y talentos.',
      'Tengo oportunidades de formación o aprendizaje continuo.',
      'Manejo bien mi tiempo y productividad en el ámbito laboral.',
      'Recibo reconocimiento o retroalimentación sobre mi desempeño.',
      'Tengo un plan de carrera o proyección a futuro.',
      'Me relaciono positivamente con compañeros y superiores.'
    ]
  },
  {
    id: 'social',
    name: 'Social',
    color: '#ba68c8',
    questions: [
      'Tengo un círculo social con el que disfruto compartir.',
      'Participo en actividades sociales con regularidad.',
      'Tengo amistades o redes de apoyo confiables.',
      'Me siento a gusto con mis interacciones sociales.',
      'Equilibro mi vida social con otras áreas importantes.',
      'Aporto a mi comunidad (voluntariado, colaboración) cuando puedo.',
      'Me comunico con respeto y empatía en mis relaciones sociales.',
      'Conozco personas nuevas o amplío mi red de contactos.'
    ]
  },
  {
    id: 'recreacion',
    name: 'Recreación',
    color: '#4db6ac',
    questions: [
      'Disfruto de actividades de ocio y entretenimiento con frecuencia.',
      'Dedico tiempo a pasatiempos o hobbies que me apasionan.',
      'Practico actividades que me diviertan y relajen.',
      'Planifico escapadas o vacaciones periódicas.',
      'Me permito descansar sin sentirme culpable.',
      'Incluyo variedad de actividades recreativas en mi rutina.',
      'Me doy recompensas o premios personales al lograr metas.',
      'Mis momentos de recreación me ayudan a recargar energías.'
    ]
  },
  {
    id: 'espiritualidad',
    name: 'Espiritualidad',
    color: '#7986cb',
    questions: [
      'Tengo una práctica o filosofía espiritual que me guíe.',
      'Dedico tiempo a la reflexión interna o meditación.',
      'Me siento conectado/a con algo más grande que yo (naturaleza, divinidad, etc.).',
      'Busco propósito y sentido en lo que hago.',
      'Cultivo valores y principios que rigen mi vida.',
      'Practico la gratitud de manera consciente.',
      'Me siento en paz conmigo mismo/a y con los demás.',
      'Estoy abierto/a a aprender y a trascender mis límites personales.'
    ]
  },
  {
    id: 'desarrollo_personal',
    name: 'Desarrollo Personal',
    color: '#4dd0e1',
    questions: [
      'Tengo metas y planes claros para mi crecimiento personal.',
      'Dedico tiempo a aprender nuevas habilidades o conocimientos.',
      'Me esfuerzo por mejorar mi autoestima y autoconfianza.',
      'Soy capaz de adaptarme a los cambios y retos de la vida.',
      'Busco retroalimentación para mejorar.',
      'Reflexiono sobre mis acciones y resultados.',
      'Tengo mentores o guías que me apoyan en mi crecimiento.',
      'Siento que evoluciono y crezco de manera constante.'
    ]
  },
  {
    id: 'pareja',
    name: 'Pareja',
    color: '#f06292',
    questions: [
      'Me siento valorado/a y amado/a por mi pareja.',
      'Hay comunicación abierta y asertiva en nuestra relación.',
      'Compartimos tiempo de calidad y proyectos en común.',
      'Expreso mi cariño y lo recibo de manera equilibrada.',
      'Resolvemos los conflictos de manera constructiva.',
      'Hay confianza y respeto mutuo.',
      'Siento que crecemos juntos como pareja.',
      'Hacemos planes que refuerzan nuestro vínculo a largo plazo.'
    ]
  }
];

// Info expandible para la pregunta de las 3 tareas
export const tareasInfo = {
  title: '¿Qué son las 3 tareas semanales?',
  content: `Se refiere a identificar **las 3 cosas que, pase lo que pase, terminás haciendo todas las semanas** en tu trabajo/negocio (aunque cambie el caos, el ánimo o el día).

Suelen ser:
• **Lo que más impacta resultados** (dinero, orden, clientes, entregas)
• **Lo que más te come tiempo** (porque nadie más lo hace o no está estandarizado)

**Ejemplos si tenés negocio/empresa:**
• Revisar ventas / pagos / cobranzas
• Coordinar al equipo (asignar turnos, resolver problemas)
• Comprar insumos / controlar stock
• Revisar publicidad / mensajes de clientes / leads

**Si sos profesional que atiende gente:**
• Agenda y confirmación de turnos
• Seguimiento de pacientes/clientes
• Preparar material/entregables

**Si sos creador/marketing:**
• Planificar contenidos
• Grabar/editar/publicar
• Responder comentarios/DMs/leads

**¿Por qué te lo pregunto?**
Porque esas 3 tareas son el núcleo para armar tu checklist semanal, automatizarlas o delegarlas.

**Pensá:** "Si me sacás todo lo demás, ¿qué 3 cosas hago igual cada semana?"`
};

// Coaching Questions divided into sections
export const coachingQuestions = {
  sectionA: {
    title: 'Preguntas Iniciales',
    questions: [
      { id: 'a1', text: '¿A qué te dedicás hoy y cómo es tu situación actual?', type: 'textarea' },
      { id: 'a2', text: 'Contame tu día: desde que te levantás hasta que te dormís (horarios reales).', type: 'textarea' },
      { id: 'a3', text: '¿A qué hora te levantás y a qué hora te acostás normalmente?', type: 'text' },
      { id: 'a4', text: '¿Cuánto "tiempo libre real" te queda por día? (sin trabajo, sin familia, sin obligaciones)', type: 'text' },
      { id: 'a5', text: '¿Con qué te estás encontrando más?', type: 'multiselect', options: ['Falta de foco', 'Ansiedad', 'Cansancio', 'Dispersión', 'Miedo a decidir', 'Desorden', 'Otro'], allowOther: true }
    ]
  },
  sectionB: {
    title: 'Contexto Personal y Familia',
    questions: [
      { id: 'b1', text: '¿Vivís con quién? (solo/a, pareja, familia)', type: 'select', options: ['Solo/a', 'Con pareja', 'Con familia', 'Compartido'] },
      { id: 'b2', text: '¿Pareja: estás en relación, soltero/a, separado/a?', type: 'select', options: ['En relación', 'Soltero/a', 'Separado/a', 'Viudo/a'] },
      { id: 'b3', text: 'Si hay pareja: ¿Cómo está la relación hoy?', type: 'select', options: ['Muy bien', 'Bien', 'Con tensión', 'Distante', 'No aplica'], conditional: 'b2', showIf: 'En relación' },
      { id: 'b4', text: '¿Tenés hijos?', type: 'select', options: ['Sí', 'No'] },
      { id: 'b5', text: '¿Cuántos hijos tenés y qué edades tienen?', type: 'textarea', conditional: 'b4', showIf: 'Sí' },
      { id: 'b6', text: '¿Cómo es la dinámica diaria con ellos?', type: 'textarea', conditional: 'b4', showIf: 'Sí' }
    ]
  },
  sectionC: {
    title: 'Dinero / Trabajo / Profesión',
    questions: [
      { id: 'c2', text: '¿Qué te da miedo que pase si tomás una decisión grande ahora?', type: 'textarea' },
      { id: 'c3', text: '¿Qué querés: mantener estabilidad o construir algo nuevo desde cero?', type: 'select', options: ['Mantener estabilidad', 'Construir algo nuevo', 'Un poco de ambos'] },
      { id: 'c4', text: '¿Tenés claro "qué vendés" hoy (producto/servicio)?', type: 'select', options: ['Sí, muy claro', 'Más o menos', 'No, nada claro'] },
      { id: 'c5', text: 'Si querés vender servicios: ¿Qué experiencia real ya probaste con personas? (aunque haya sido gratis)', type: 'textarea' },
      { id: 'c6', text: '¿Qué proyecto te entusiasma aunque hoy te parezca "grande"?', type: 'textarea' }
    ]
  },
  sectionD: {
    title: 'Rutina, Energía y Hábitos',
    questions: [
      { id: 'd1', text: '¿Cómo dormís? (¿te despertás? ¿descansás?)', type: 'select', options: ['Muy bien', 'Bien', 'Regular', 'Mal', 'Muy mal'] },
      { id: 'd2', text: '¿Café o estimulantes: consumís? ¿cuánto?', type: 'text' },
      { id: 'd3', text: 'Ejercicio: ¿hacés? ¿qué tipo? ¿cuántos días/semana?', type: 'textarea' },
      { id: 'd4', text: 'Comida: ¿comés más en casa o afuera?', type: 'select', options: ['Siempre en casa y me cocino', 'Siempre en casa pero pido comidas', 'Mayormente en casa', 'Mitad y mitad', 'Mayormente afuera'] },
      { id: 'd5', text: '¿Cómo estás con tu peso corporal?', type: 'textarea' },
      { id: 'd6', text: 'Digestión: ¿cómo está tu intestino? (regularidad / hinchazón / estreñimiento / diarrea)', type: 'textarea' },
      { id: 'd7', text: '¿Notás bruma mental / cambios de ánimo según lo que comés o cómo dormís?', type: 'select', options: ['Sí, mucho', 'A veces', 'No lo noto'] },
      { id: 'd8', text: '¿Realizás ayunos? Si es así, explicá: ¿son intermitentes, de 24 horas, de 3 o 5 días?', type: 'textarea' },
      { id: 'd9', text: '¿Tenés algún diagnóstico o medicación que deba tener en cuenta?', type: 'textarea' }
    ]
  },
  sectionE: {
    title: 'Sustancias (opcional)',
    questions: [
      { id: 'e1', text: '¿Consumís alguna de estas sustancias?', type: 'multiselect', options: ['Alcohol', 'Cannabis', 'Tabaco', 'Otras sustancias', 'Ninguna'] },
      { id: 'e2', text: 'Si consumís: ¿Con qué frecuencia y en qué horarios?', type: 'textarea', conditional: 'e1', showIfNot: 'Ninguna' },
      { id: 'e3', text: '¿Te interesa reducir el consumo o por ahora no es prioridad?', type: 'select', options: ['Sí, quiero reducir', 'No es prioridad', 'No aplica'], conditional: 'e1', showIfNot: 'Ninguna' }
    ]
  },
  sectionF: {
    title: 'Organización y Productividad',
    questions: [
      { id: 'f1', text: 'Hoy, ¿qué parte es caos: tu agenda, tu casa, tu cabeza o tu negocio?', type: 'select', options: ['Mi agenda', 'Mi casa', 'Mi cabeza', 'Mi negocio/trabajo', 'Todo', 'Nada'] },
      { id: 'f2', text: '¿Usás listas/checklists o todo va "en la mente"?', type: 'select', options: ['Uso listas siempre', 'A veces', 'Todo en la mente'] },
      { id: 'f3', text: '¿Qué 3 tareas repetís todas las semanas sí o sí?', type: 'textarea', hasInfo: true, infoKey: 'tareasInfo' },
      { id: 'f4', text: '¿Cuál es tu 80/20? (el 20% que te da el 80% de resultados)', type: 'textarea' },
      { id: 'f5', text: 'Si hay desorden: ¿Cómo está tu dormitorio/ropero/escritorio?', type: 'textarea' },
      { id: 'f6', text: '¿Qué podrías delegar ya mismo, aunque sea una parte pequeña?', type: 'textarea' }
    ]
  },
  sectionG: {
    title: 'Negocio/Empresa/Delegación',
    questions: [
      { id: 'g1', text: '¿Tenés equipo o gente a cargo?', type: 'select', options: ['Sí', 'No', 'Trabajo solo/a'] },
      { id: 'g2', text: '¿Qué cosas hacés vos que "no deberían ser tuyas"?', type: 'textarea', conditional: 'g1', showIf: 'Sí' },
      { id: 'g3', text: '¿Tenés KPIs/OKRs o algún tablero de métricas?', type: 'select', options: ['Sí', 'No', 'No sé qué es'] },
      { id: 'g4', text: '¿Grabás reuniones, registrás procesos o los transcribís?', type: 'select', options: ['Sí, siempre', 'A veces', 'Nunca'] },
      { id: 'g5', text: 'Si contrataras a alguien 3 meses: ¿qué rol te libera más?', type: 'select', options: ['Asistente', 'Operaciones', 'Ventas', 'Técnico', 'Otro'] }
    ]
  },
  sectionH: {
    title: 'IA y Herramientas',
    questions: [
      { id: 'h1', text: '¿Cómo estás con IA? (ChatGPT / Claude / Gemini)', type: 'select', options: ['La uso mucho', 'La uso a veces', 'La probé poco', 'No la uso'] },
      { id: 'h2', text: '¿Te animás a grabar/transcribir conversaciones y preguntarle a una IA: "¿Qué es lo que se repite?"?', type: 'select', options: ['Ya lo hago', 'Sí, me interesa', 'Tal vez', 'No me interesa'] }
    ]
  },
  sectionJ: {
    title: 'Sobre la Rueda de la Vida',
    questions: [
      { id: 'j1', text: '¿Cómo te fue con la Rueda de la Vida? (¿ya la habías hecho antes?)', type: 'textarea' },
      { id: 'j3', text: '¿Qué te sorprendió o qué se repite siempre cuando la hacés?', type: 'textarea' },
      { id: 'j4', text: 'Si tuvieras que elegir UNA cosa para destrabar ahora mismo: ¿cuál sería?', type: 'textarea' }
      // La pregunta sobre las 3 áreas más bajas se genera dinámicamente
    ]
  },
  sectionK: {
    title: 'Sobre tus Objetivos',
    questions: [
      { id: 'k1', text: 'De los objetivos 3/6/9 meses: ¿qué te salió más claro y qué te trabó?', type: 'textarea' }
    ]
  },
  sectionL: {
    title: 'Cierre y Compromisos',
    questions: [
      { id: 'l1', text: '¿Qué 1–3 acciones vas a hacer en los próximos 7 días?', type: 'textarea' },
      { id: 'l3', text: '¿Alguna pregunta puntual antes de cerrar?', type: 'textarea' }
    ]
  }
};

export const getQuestionSections = () => {
  return Object.entries(coachingQuestions).map(([key, section]) => ({
    key,
    ...section
  }));
};

// Genera preguntas dinámicas basadas en las áreas de la rueda con puntaje bajo (< 4)
export const generateLowScoreQuestions = (wheelData) => {
  const questions = [];
  
  if (!wheelData || Object.keys(wheelData).length === 0) {
    return questions;
  }
  
  // Get all areas with their scores
  const areasWithScores = wheelCategories
    .map(category => {
      const catData = wheelData[category.id];
      return {
        id: category.id,
        name: category.name,
        score: catData ? catData.score : 10 // Default high score if not set
      };
    })
    .filter(area => area.score < 10) // Only include areas that have been scored
    .sort((a, b) => a.score - b.score); // Sort by score ascending (lowest first)
  
  // Get the 3 lowest areas
  const lowest3 = areasWithScores.slice(0, 3);
  
  if (lowest3.length > 0) {
    // Format: "Vida (3.5), Pareja (3.8) y Profesional (4.7)"
    let areasText = '';
    if (lowest3.length === 1) {
      areasText = `${lowest3[0].name} (${lowest3[0].score.toFixed(1)})`;
    } else if (lowest3.length === 2) {
      areasText = `${lowest3[0].name} (${lowest3[0].score.toFixed(1)}) y ${lowest3[1].name} (${lowest3[1].score.toFixed(1)})`;
    } else {
      areasText = `${lowest3[0].name} (${lowest3[0].score.toFixed(1)}), ${lowest3[1].name} (${lowest3[1].score.toFixed(1)}) y ${lowest3[2].name} (${lowest3[2].score.toFixed(1)})`;
    }
    
    questions.push({
      id: 'wheel_lowest_3',
      text: `¿Por qué ${areasText} fueron tus áreas más bajas?`,
      type: 'textarea',
      isDynamic: true,
      lowestAreas: lowest3
    });
  }
  
  return questions;
};
